import { LOGIN_REFERRER } from 'src/common/constants';

export const NO_REFER_PATHS = ['/not-found', '/500', '/login', '/r/500', '/r/not-found', '/r/login'];

export const getLoginReferrer = () => {
  const referrer = window.sessionStorage.getItem(LOGIN_REFERRER);

  if (referrer) {
    const shouldNotRefer = NO_REFER_PATHS.some((noReferPath) => referrer.startsWith(noReferPath));

    if (shouldNotRefer) {
      return null;
    }
    return referrer;
  }
  return null;
};
